import { FC } from 'react';
import { Grid } from '@mui/material';
import { FieldRow, FieldLabel, RadioLabel } from 'src/generic/component';
import { BooleanRadio, TextArea, IntegerInput } from 'src/generic/component/form';
import { IFieldProps } from 'src/generic/type/form';
import { ErrorManager } from 'src/types/validation';

export const AuthorizationLevel: FC<IFieldProps<{ appliedLevel?: '1' | '2'; }>> = ({ item: initial, errors, readOnly, onUpdate }) => {
  const { getError, hasError } = ErrorManager(errors);
  const { appliedLevel } = initial;

  const changed = (updates: { appliedLevel?: '1' | '2'; }) => {
    if (onUpdate) {
      onUpdate({ ...initial, ...updates });
    }
  };

  return (
    <FieldRow>
      <FieldLabel variant="body1">Authorization Level</FieldLabel>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '8px',
        width: '100%'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          cursor: 'pointer',
          width: '100%'
        }}>
          <input
            type="radio"
            name="appliedLevel"
            value="1"
            checked={appliedLevel === '1'}
            disabled={readOnly}
            onChange={(e) => {
              if (e.target.checked) {
                changed({ appliedLevel: '1' });
              }
            }}
            style={{
              marginTop: '4px',
              flexShrink: 0,
              width: '16px',
              height: '16px'
            }}
          />
          <span style={{
            color: 'rgba(0, 0, 0, 0.87)',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.5,
            letterSpacing: '0.00938em',
            flex: 1
          }}>
            <strong>Level 1 Authorization:</strong> Required for schools to receive their students’ Pre-AP, AP Exam, PSAT, SAT and other College Board test scores. Schools cannot administer AP, PSAT, SAT or other College Board exams but can participate in the AP Course Audit and Pre-AP program.
          </span>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '12px',
          cursor: 'pointer',
          width: '100%'
        }}>
          <input
            type="radio"
            name="appliedLevel"
            value="2"
            checked={appliedLevel === '2'}
            disabled={readOnly}
            onChange={(e) => {
              if (e.target.checked) {
                changed({ appliedLevel: '2' });
              }
            }}
            style={{
              marginTop: '4px',
              flexShrink: 0,
              width: '16px',
              height: '16px'
            }}
          />
          <span style={{
            color: 'rgba(0, 0, 0, 0.87)',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: '1rem',
            lineHeight: 1.5,
            letterSpacing: '0.00938em',
            flex: 1
          }}>
            <strong>Level 2 Authorization:</strong> Required for schools to receive scores as well as administer AP Exams and PSAT-related assessments and to apply to become a SAT Test Center.
          </span>
        </div>
      </div>
      {hasError('appliedLevel') && (
        <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '8px' }}>
          {getError('appliedLevel')}
        </div>
      )}
    </FieldRow>
  );
};